import { Outlet } from '@tanstack/react-router';
import { experimentalStyled } from '@material-ui/core/styles';
import Footer from './Footer';
import WebsiteNavbar from './Navbar';

const WebsiteLayoutRoot = experimentalStyled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  height: '100%',
  paddingTop: 64
}));

const WebsiteLayout = ({ children }) => {

  return (
    <WebsiteLayoutRoot>
      <WebsiteNavbar />
      {children || <Outlet />}
      <Footer />
    </WebsiteLayoutRoot>
  );
};

export default WebsiteLayout;
